import React from 'react'
import CustomLink from '../Link'

import './styles.scss'
import './styles-mobile.scss'

const BannerFixo = () => (
  <div class="gallery js-flickity" data-flickity-options='{"wrapAround": true, "groupCells": true, "autoPlay": false }'>
    <div class="carousel-cell"></div>
    <div class="carousel-cell"></div>
    <div class="carousel-cell"></div>
    <div class="carousel-cell"></div>
    <div class="carousel-cell"></div>
    <div class="carousel-cell"></div>
    <div class="carousel-cell"></div>
    <div class="carousel-cell"></div>
    <div class="carousel-cell"></div>
    <div class="carousel-cell"></div>
    <div class="carousel-cell"></div>
    <div class="carousel-cell"></div>
  </div>
)

export default BannerFixo
